module.exports = __webpack_public_path__ + "static/img/Bachelor_010685.89e8d22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010685.jpg
// module id = 211
// module chunks = 0